import { GetterTree } from 'vuex';

import { FilesStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<FilesStateI, RootStateI> = {
};
